import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLogin } from "../../../APIContext/LoginContext";
import { FiChevronDown } from "react-icons/fi";
import "./dashsidebar.css";

const DashSidebar = () => {
  const location = useLocation();
  const { user, logout } = useLogin();
  const [userMgmtOpen, setUserMgmtOpen] = useState(false);
  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false);

  const isActive = (path) => location.pathname.startsWith(path);
  const isSubActive = (path) => location.pathname === path;
  const toggleUserMgmt = () => setUserMgmtOpen(!userMgmtOpen);
  const type_selfpay = user?.is_self_pay;
  if (!user) return null;

  const menuItems = [
    { path: "/profile", label: "Profile", check: isActive },
    { path: "/your-players", label: "Your Players", check: isActive },
    {
      path: "/saved-payment-method",
      label: "Saved Payment Method",
      check: isSubActive,
    },
    {
      path: "/my-payment-details",
      label: "My Payment Details",
      check: isSubActive,
      condition: type_selfpay,
    },
    {
      path: "/view-all-sessions",
      label: "View all Sessions",
      check: isActive,
    },
    {
      path: "/my-package-plans",
      label: "My Packages & Plans",
      check: isActive,
      condition: type_selfpay,
    },
    { path: "/notifications", label: "Notifications", check: isActive },
    { path: "/change-password", label: "Change Password", check: isActive },

    
  ];

  const activeItem = menuItems.find(
    (item) =>
      (item.condition === undefined || item.condition) && item.check(item.path),
  );

  const activeLabel = activeItem ? activeItem.label : "Menu";

  return (
    <>
      <div className="sidebar">
        <div className={`sidebar-item ${isActive("/profile") ? "active" : ""}`}>
          <Link to="/profile">
            <span className="black-text-clip">Profile</span>
          </Link>
        </div>

        <div
          className={`sidebar-item ${isActive("/your-players") ? "active" : ""}`}
        >
          <Link to="/your-players">
            <span className="black-text-clip">Your Players</span>
          </Link>
        </div>

        <div
          className={`sidebar-item ${userMgmtOpen ? "has-active" : ""}`}
          onClick={toggleUserMgmt}
        >
          <span className="black-text-clip">Payments & Billings</span>
        </div>
        {userMgmtOpen && (
          <div className="dropdown">
            <div
              className={`sidebar-subitem ${isSubActive("/saved-payment-method") ? "active" : ""}`}
            >
              <Link to="/saved-payment-method">
                <span className="black-text-clip">Saved Payment Method</span>
              </Link>
            </div>
            {type_selfpay && (
              <div
                className={`sidebar-subitem ${isSubActive("/my-payment-details") ? "active" : ""}`}
              >
                <Link to="/my-payment-details">
                  <span className="black-text-clip">My Payment Details</span>
                </Link>
              </div>
            )}
          </div>
        )}

        <div
          className={`sidebar-item ${isActive("/view-all-sessions") ? "active" : ""}`}
        >
          <Link to="/view-all-sessions">
            <span className="black-text-clip">View all Sessions</span>
          </Link>
        </div>

        {type_selfpay && (
          <div
            className={`sidebar-item ${isActive("/my-package-plans") ? "active" : ""}`}
          >
            <Link to="/my-package-plans">
              <span className="black-text-clip">My Packages & Plans</span>
            </Link>
          </div>
        )}

        <div
          className={`sidebar-item ${isActive("/notifications") ? "active" : ""}`}
        >
          <Link to="/notifications">
            <span className="black-text-clip">Notifications</span>
          </Link>
        </div>

        <div
          className={`sidebar-item ${isActive("/change-password") ? "active" : ""}`}
        >
          <Link to="/change-password">
            <span className="black-text-clip">Change Password</span>
          </Link>
        </div>

        <div className="sidebar-item" onClick={logout}>
          <span className="black-text-clip">Log Out</span>
        </div>
      </div>
      {/* Side bar mobile */}
      <div className="sidebar-mobile">
        <button
          onClick={() => {
            setSidebarMobileOpen(!sidebarMobileOpen);
          }}
          className="sidebar-mobile-button"
        >
          {activeLabel}
          <span>
            <FiChevronDown
              style={{
                transform: sidebarMobileOpen
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
            />
          </span>
        </button>
        {sidebarMobileOpen && (
          <div className="sidebar-dropdown">
            <Link to="/profile">
              <div
                onClick={() => {
                  setSidebarMobileOpen(!sidebarMobileOpen);
                }}
                className={`sidebar-item ${isActive("/profile") ? "active" : ""}`}
              >
                <span className="black-text-clip">Profile</span>
              </div>
            </Link>
            <Link to="/your-players">
              <div
                onClick={() => {
                  setSidebarMobileOpen(!sidebarMobileOpen);
                }}
                className={`sidebar-item ${isActive("/your-players") ? "active" : ""}`}
              >
                <span className="black-text-clip">Your Players</span>
              </div>
            </Link>
            <div
              className={`sidebar-item ${userMgmtOpen ? "has-active" : ""}`}
              onClick={toggleUserMgmt}
            >
              <span className="black-text-clip">Payments & Billings</span>
            </div>
            {userMgmtOpen && (
              <div className="dropdown">
                <Link to="/saved-payment-method">
                  <div
                    onClick={() => {
                      setSidebarMobileOpen(!sidebarMobileOpen);
                    }}
                    className={`sidebar-subitem ${isSubActive("/saved-payment-method") ? "active" : ""}`}
                  >
                    <span className="black-text-clip">
                      Saved Payment Method
                    </span>
                  </div>
                </Link>
                {type_selfpay && (
                  <Link to="/my-payment-details">
                    <div
                      onClick={() => {
                        setSidebarMobileOpen(!sidebarMobileOpen);
                      }}
                      className={`sidebar-subitem ${isSubActive("/my-payment-details") ? "active" : ""}`}
                    >
                      <span className="black-text-clip">
                        My Payment Details
                      </span>
                    </div>
                  </Link>
                )}
              </div>
            )}
            <Link to="/view-all-sessions">
              <div
                onClick={() => {
                  setSidebarMobileOpen(!sidebarMobileOpen);
                }}
                className={`sidebar-item ${isActive("/view-all-sessions") ? "active" : ""}`}
              >
                <span className="black-text-clip">View all Sessions</span>
              </div>
            </Link>
            {type_selfpay && (
              <Link to="/my-package-plans">
                <div
                  onClick={() => {
                    setSidebarMobileOpen(!sidebarMobileOpen);
                  }}
                  className={`sidebar-item ${isActive("/my-package-plans") ? "active" : ""}`}
                >
                  <span className="black-text-clip">My Packages & Plans</span>
                </div>
              </Link>
            )}
            <Link to="/notifications">
              <div
                onClick={() => {
                  setSidebarMobileOpen(!sidebarMobileOpen);
                }}
                className={`sidebar-item ${isActive("/notifications") ? "active" : ""}`}
              >
                <span className="black-text-clip">Notifications</span>
              </div>
            </Link>
            <Link to="/change-password">
              <div
                onClick={() => {
                  setSidebarMobileOpen(!sidebarMobileOpen);
                }}
                className={`sidebar-item ${isActive("/change-password") ? "active" : ""}`}
              >
                <span className="black-text-clip">Change Password</span>
              </div>
            </Link>
            <div
              className="sidebar-item"
              onClick={() => {
                logout();
                setSidebarMobileOpen(!sidebarMobileOpen);
              }}
            >
              <span className="black-text-clip">Log Out</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DashSidebar;
